import type { PageRoute } from '../../page-route';
import { OAuthInteractionPage } from './page';

/** Вход и согласие ИИ-агента (005, research R15): без сессии табеля и вне оболочки, как страница входа. */
export const route: PageRoute = {
  path: '/oauth/interaction/:uid',
  access: 'public',
  Component: OAuthInteractionPage,
};
